// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__34fkU","inputWrap":"Table_inputWrap__3-MS3","col":"Table_col__1sAsE","bmiTooltip":"Table_bmiTooltip__1b-xo"};